import { Parameter } from '../../../models/index';
import { UseCase } from '../../UseCase';

interface Profiles {
    [key: string]: Profile;
}

export interface Profile {
    parameters: Array<Parameter<string, string>>;
}

export interface ProfileParameters {
    defaults?: Object;
    profiles?: Profiles;
}

export namespace GetProfileParameter {
    export interface Params<P extends string> {
        params?: ProfileParameters;
        name: P;
        herdId: number;
    }
}

export class GetProfileParameter<P extends string>
    implements UseCase<GetProfileParameter.Params<P>, string | number | undefined>
{
    execute<V extends string | number>({
        params,
        name,
        herdId
    }: GetProfileParameter.Params<P>): V | undefined {
        const profileId = herdId && herdId.toString();
        if (params && params.profiles) {
            if (params.profiles[profileId] && params.profiles[profileId].parameters) {
                const param = params.profiles[profileId].parameters.find((p) => p.name === name);

                return param && <V>param.value;
            } else if (params.profiles['all'] && params.profiles['all'].parameters) {
                const param = params.profiles['all'].parameters.find((p) => p.name === name);

                return param && <V>param.value;
            }
        }

        return undefined;
    }
}
